import { Checkbox as ChakraCheckbox } from '@chakra-ui/react'
import * as React from 'react'

export interface CheckboxProps extends ChakraCheckbox.RootProps {
  icon?: React.ReactNode
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>
  rootRef?: React.RefObject<HTMLLabelElement | null>
}

export const Checkbox: React.FC<CheckboxProps> = (props) => {
  const { icon, children, inputProps, ref, ...rest } = props

  return (
    <ChakraCheckbox.Root colorPalette="blue" {...rest}>
      <ChakraCheckbox.HiddenInput ref={ref} {...inputProps} />
      <ChakraCheckbox.Control cursor="pointer">
        {icon || <ChakraCheckbox.Indicator />}
      </ChakraCheckbox.Control>
      {children != null && <ChakraCheckbox.Label cursor="pointer">{children}</ChakraCheckbox.Label>}
    </ChakraCheckbox.Root>
  )
}
